<template>
  <div id="main-one-wrap">
    <div class="main-two-wrap">
        <ul>
            <li class="item-li-nav">
                <div class="wrap-hover">
                    <a href="javascript: void(0);" class="a-style icon-QQkf">QQ客服</a>
                    <div class="ptn-add ptn-top">
                        <i></i>
                        <a href="http://wpa.qq.com/msgrd?v=3&uin=3502607950&site=qq&menu=yes" target="_blank">QQ客服速小派</a>
                        <a href="http://wpa.qq.com/msgrd?v=3&uin=1451232104&site=qq&menu=yes" target="_blank">QQ客服西门子考核</a>
                    </div>
                </div>
            </li>
            <li class="item-li-nav">
                <div class="wrap-hover">
                    <a href="javascript: void(0);" class="a-style icon-spAPP">速派APP</a>
                    <div class="ptn-add ptn-top2">
                        <span>
                            <img src="../assets/fixedRight/supaiapp_ercode.png" alt="" />
                        </span>
                        <div>
                            <p>工控速派</p>
                            <p>扫码下载APP</p>
                        </div>
                    </div>
                </div>
            </li>
            <li class="item-li-nav">
                <div class="wrap-hover">
                    <a href="javascript: void(0);" class="a-style icon-wxgzh">微信公众号</a>
                    <div class="ptn-add ptn-top2">
                        <span>
                            <img src="../assets/fixedRight/supaiweixin_ercode.jpg" alt="" />
                        </span>
                        <div>
                            <p>工控速派</p>
                            <p>微信公众号</p>
                        </div>
                    </div>
                </div>
            </li>
            <li class="item-li-nav">
                <div class="wrap-hover">
                    <a href="javascript: void(0);" class="a-style icon-kfphone">客服电话</a>
                    <div class="ptn-add ptn-top3">
                        <a href="javascript: void(0);">客服电话：400-1100-243</a>
                    </div>
                </div>
            </li>
            <li class="item-li-nav">
                <div class="wrap-hover">
                    <a :href="helpCenter" class="a-style icon-bzzx">帮助中心</a>
                    <div class="ptn-add ptn-top3">
                        <a :href="helpCenter">速派帮助中心，为您排忧解惑</a>
                    </div>
                </div>
            </li>
            <li :class="['item-li-nav return-top',{'active':showTop}]" @click="backTop">
                <div class="wrap-hover">
                    <a href="javascript: void(0);" class="a-style icon-fhdb">返回顶部</a>
                </div>
            </li>
        </ul>
    </div>
  </div>
</template>
<script>
import {p_origin} from '@/scripts/util.js'
export default {
  data(){
    return{
      showTop:false,
      helpCenter:p_origin+'/Help/helpCenter_01.html'
    }
  },
  mounted() {
    this.docScroll();
  },
  methods:{
    docScroll(){
      document.onscroll=(e)=> {
        let top=document.documentElement.scrollTop;
        if(top>100){
          this.showTop=true;
        }else{
          this.showTop=false;
        }
      }
    },
    backTop(){
      window.scrollTo({
          top:0,
          behavior:'smooth'
      })
    }
  }
}
</script>
<style lang="scss">
#main-one-wrap{
  right: 20px;
  position: fixed;
  top: 36%;
  z-index: 2;
  a:focus {
    outline: none;
  }
  .main-two-wrap ul {
      margin-bottom: 0;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover {
      position: relative;
      background: #666;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover a.a-style {
      width: 54px;
      height: 54px;
      display: block;
      background-position: center center;
      background-size: 70%;
      background-repeat: no-repeat;
      border-top: 1px solid #fff;
      font-size: 0;
  }

  .main-two-wrap ul li.item-li-nav:first-child>a.a-style {
      border-top: none;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover a.icon-QQkf {
      background-image: url(../assets/fixedRight/fixed_1_kf.png);
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover a.icon-spAPP {
      background-image: url(../assets/fixedRight/fixed_2_app.png);
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover a.icon-wxgzh {
      background-image: url(../assets/fixedRight/fixed_3_gzh.png);
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover a.icon-kfphone {
      background-image: url(../assets/fixedRight/fixed_4_dh.png);
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover a.icon-bzzx {
      background-image: url(../assets/fixedRight/fixed_6_bz.png);
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover a.icon-fhdb {
      background-image: url(../assets/fixedRight/fixed_5_db.png);
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-add {
      display: block;
      position: absolute;
      right: 54px;
      min-width: 150px;
      display: none;
      top: 1px;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top>a {
      display: block;
      width: 100%;
      height: 53px;
      display: block;
      text-align: center;
      background-color: #f75959;
      color: #fff;
      line-height: 54px;
      white-space: nowrap;
      text-align: right;
      padding-left: 15px;
      padding-right: 15px;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top {
      top: -89px;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top a {
      text-align: center;
      margin-bottom: 1px;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top i {
      display: block;
      width: 82px;
      height: 100px;
      background-image: url(../assets/fixedRight/su_xiao_pai.png);
      margin: 0 auto;
      margin-bottom: -10px;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top2 {
      padding: 20px;
      background-color: #f75959;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top2 span {
      display: block;
      width: 85px;
      height: 85px;
      margin: 0 auto;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top2 span img {
      display: block;
      max-width: 100%;
      height: auto;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top2 div {
      padding-top: 10px;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top2 div p {
      margin-bottom: 0;
      color: #fff;
      text-align: center;
      font-size: 12px;
      line-height: 22px;
  }

  .main-two-wrap ul li.item-li-nav .wrap-hover .ptn-top3>a {
      display: block;
      width: 100%;
      height: 53px;
      display: block;
      text-align: right;
      background-color: #f75959;
      color: #fff;
      line-height: 54px;
      white-space: nowrap;
      text-align: right;
      padding-left: 15px;
      padding-right: 15px;
  }

  .item-li-nav:hover .ptn-add {
      display: block !important;
  }

  .item-li-nav:hover .a-style {
      background-color: #f75959;
  }
  .return-top{
    opacity: 0;
    height: 0;
    transition: all 0.2s linear;
    overflow: hidden;
  }
  .return-top.active{
    height: 54px;
    opacity: 1;
  }


  /********新的右边悬浮栏end*************/

}
</style>